/** AP04 copy (one group per control; a ticket edits only its own file). */
export const ap04PtBr = {
  title: 'Ocorrências recorrentes cobertas',
  description:
    'Cada ocorrência recorrente esperada no período, comparada a uma conta ou estimativa postada.',
  prerequisite: '',
  uncoveredLabel: 'Sem conta ou estimativa postada',
  billNotPostedLabel: 'Nota sem lançamento',
  // MINOR-2 (ALC-4523 fix round 2, D36d): this row IS an uncovered occurrence — there is no bill
  // or estimate at all — so "sem conta" stays the primary wording; the currency note is
  // secondary context for why it could not simply be flagged as the plain uncovered case.
  currencyMismatchLabel: 'Sem conta ou estimativa postada — moeda diferente do livro',
  unanchoredCadenceLabel: 'Cadência sem data inicial',
  varianceOverLabel: 'Valor maior que o esperado',
  varianceUnderLabel: 'Valor menor que o esperado',
  varianceHistoryLabel: 'Diferenças entre valor esperado e realizado',
  notComparableCurrencyLabel: 'Coberta, moeda diferente — valor não comparado',
  estimatedCompetencyLabel: 'Competência estimada pela data de emissão',
  expectedLabel: 'Esperado:',
  actualLabel: 'Realizado:',
  openTemplate: 'Modelo',
  openBill: 'Conta',
  openAccrual: 'Provisão',
  unresolvedCurrencyLabel: 'Moeda funcional do livro não resolvida; comparação pendente',
  historicalStateUnknownLabel:
    'Histórico do modelo alterado após o período; cobertura pendente de confirmação',
  billReversalDateUnknownLabel:
    'Data do estorno da conta não disponível; cobertura pendente de confirmação',
  coverageGap: {
    historical: 'Histórico não reconstruível para',
    reversal: 'Data de estorno não reconstruível para',
    currentStatus: 'Estado atual',
    createdAt: 'Criado em',
    updatedAt: 'Alterado em',
    deletedAt: 'Excluído em',
    originalJournal: 'Lançamento original',
    templateStatus: {
      ACTIVE: 'Ativo',
      INACTIVE: 'Pausado',
      DRAFT: 'Rascunho',
      DELETED: 'Excluído',
    },
    billStatus: {
      DRAFT: 'Rascunho',
      SUBMITTED: 'Enviado',
      PENDING_APPROVAL: 'Pendente de aprovação',
      APPROVED: 'Aprovado',
      REJECTED: 'Rejeitado',
      PARTIALLY_PAID: 'Parcialmente pago',
      PAID: 'Pago',
      COMPLETED: 'Concluído',
      VOID: 'Cancelado',
      MIGRATED: 'Migrado',
    },
  },
};

export const ap04En: typeof ap04PtBr = {
  title: 'Covered recurring occurrences',
  description:
    'Each recurring occurrence expected in the period, compared against a posted bill or estimate.',
  prerequisite: '',
  uncoveredLabel: 'No posted bill or estimate',
  billNotPostedLabel: 'Bill not posted',
  currencyMismatchLabel: 'No posted bill or estimate — different currency from the book',
  unanchoredCadenceLabel: 'Cadence without a start date',
  varianceOverLabel: 'Higher than expected',
  varianceUnderLabel: 'Lower than expected',
  varianceHistoryLabel: 'Differences between expected and actual values',
  notComparableCurrencyLabel: 'Covered, different currency — amount not compared',
  estimatedCompetencyLabel: 'Competency estimated from the issue date',
  expectedLabel: 'Expected:',
  actualLabel: 'Actual:',
  openTemplate: 'Template',
  openBill: 'Bill',
  openAccrual: 'Accrual',
  unresolvedCurrencyLabel: 'Book functional currency is unresolved; comparison pending',
  historicalStateUnknownLabel: 'Template changed after the period; coverage needs confirmation',
  billReversalDateUnknownLabel: 'Bill reversal date unavailable; coverage needs confirmation',
  coverageGap: {
    historical: 'History cannot be reconstructed for',
    reversal: 'Reversal date cannot be reconstructed for',
    currentStatus: 'Current status',
    createdAt: 'Created',
    updatedAt: 'Updated',
    deletedAt: 'Deleted',
    originalJournal: 'Original journal',
    templateStatus: {
      ACTIVE: 'Active',
      INACTIVE: 'Paused',
      DRAFT: 'Draft',
      DELETED: 'Deleted',
    },
    billStatus: {
      DRAFT: 'Draft',
      SUBMITTED: 'Submitted',
      PENDING_APPROVAL: 'Pending approval',
      APPROVED: 'Approved',
      REJECTED: 'Rejected',
      PARTIALLY_PAID: 'Partially paid',
      PAID: 'Paid',
      COMPLETED: 'Completed',
      VOID: 'Voided',
      MIGRATED: 'Migrated',
    },
  },
};
